import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export const useChangePermitsIndexing = ({ orderId }: { orderId: string }) => {
  const { mutate, isPending } = useMutation<
    void,
    Error,
    {
      data: {
        indexing: string[];
      };
    }
  >({
    mutationFn: ({ data }) => OrdersClient.changePermitsIndexing(orderId, data),
  });

  return {
    changePermitsIndexing: mutate,
    isPending,
  };
};
